import * as Yup from "yup";
import { LABELS, NAMES } from "./Config";

let {
    TITLE,
    NOTIFICATION_TYPE,
    NOTIFICATION_MESSAGE,
    AGE_GROUP,
    USER_GROUP,
    SCHEDULE_DATE,
    SCHEDULE_TIME
} = LABELS;

export const initialValues = {
    [NAMES[TITLE]]: "",
    [NAMES[AGE_GROUP]]: null,
    [NAMES[SCHEDULE_DATE]]: null,
    [NAMES[SCHEDULE_TIME]]: null,
    [NAMES[NOTIFICATION_MESSAGE]]: "",

    [NAMES[NOTIFICATION_TYPE]]: "",
    [NAMES[USER_GROUP]]: ""
};

export const FORM_VALIDATION_SCHEMA = Yup.object({
    [NAMES[TITLE]]: Yup.string().required("Please enter the title"),

    [NAMES[AGE_GROUP]]: Yup.array().required("Please select a age group"),

    [NAMES[SCHEDULE_DATE]]: Yup.date().required("Date is required"),

    [NAMES[SCHEDULE_TIME]]: Yup.date().required("Time is required"),

    [NAMES[NOTIFICATION_MESSAGE]]: Yup.string().required("Please enter a message"),

    [NAMES[NOTIFICATION_TYPE]]: Yup.string().required(
        "Please select an option for notification type"
    ),
    [NAMES[USER_GROUP]]: Yup.string().required("Please select an option for user group")
});
